export default __webpack_public_path__ + "images/LT.2b7f654.png";